export default "__VITE_ASSET__Cpn9rNuK__"